import { su, theme } from '@adflow/frontend/ui-theme';

export function SectionDividerLine() {
	return (
		<span
			css={{
				backgroundColor: theme.colors.input.border,
				height: '1px',
			}}
		/>
	);
}

export function SectionDivider({ text }: { text?: string }) {
	return (
		<div
			css={{
				display: 'grid',
				alignItems: 'center',
				gridTemplateColumns: text ? '1fr auto 1fr' : '1fr',
				minHeight: su.textXs.lineHeight,
			}}
		>
			<SectionDividerLine />
			{text ? (
				<>
					<div
						css={[
							su.textXs,
							{
								color: theme.colors.text.secondary,
								margin: '0 0.75rem',
							},
						]}
					>
						{text}
					</div>
					<SectionDividerLine />
				</>
			) : null}
		</div>
	);
}
